import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Tratamientos',
    href: '#tratamientos'
  }, {
    name: 'Quiénes Somos',
    href: '#nosotros'
  }, {
    name: 'Resultados',
    href: '#resultados'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-ivory/80 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-116">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-117">
        {/* Logo */}
        <a href="#" className="flex flex-col" data-id="element-118">
          <span className="font-serif text-2xl md:text-3xl tracking-wide text-charcoal leading-none" data-id="element-119">
            MANTRA
          </span>
          <span className="font-sans text-[10px] md:text-xs tracking-[0.2em] text-charcoal/70 uppercase mt-1" data-id="element-120">
            Medicina Estética
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-121">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-charcoal/80 hover:text-rosegold transition-colors" data-id="element-122">
              {link.name}
            </a>)}
          <a href="#reservar" className="bg-rosegold text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-rosegold-600 transition-colors shadow-sm" data-id="element-123">
            Reservar Consulta
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-charcoal p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-124">
          {mobileMenuOpen ? <X size={24} data-id="element-125" /> : <Menu size={24} data-id="element-126" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-127">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-ivory shadow-soft border-t border-rosegold/10 py-6 px-6 flex flex-col gap-4 md:hidden" data-id="element-128">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-charcoal/80 py-2 border-b border-rosegold/10" onClick={() => setMobileMenuOpen(false)} data-id="element-129">
                {link.name}
              </a>)}
            <a href="#reservar" className="bg-rosegold text-white px-6 py-3 rounded-full text-center text-sm font-medium mt-4" onClick={() => setMobileMenuOpen(false)} data-id="element-130">
              Reservar Consulta
            </a>
          </motion.div>}
      </AnimatePresence>
    </header>;
}